import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Cyberpunk";

const asArray = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

function SeoHelmet({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage,
  ogType = "website",
  twitterCard = "summary_large_image",
  keywords,
  schema,
}) {
  const finalTitle = title ? `${title}` : SITE_NAME;
  const finalDescription = description || "CDR investigation tools and guides for lawful telecom analysis.";
  const finalCanonical = canonical || "https://www.cyberpunk.pk";
  const finalOgTitle = ogTitle || finalTitle;
  const finalOgDescription = ogDescription || finalDescription;
  const finalOgUrl = ogUrl || ogUrl === "" ? ogUrl : finalCanonical;
  const finalOgImage = ogImage || "https://www.cyberpunk.pk/logo512.png";

  return (
    <Helmet prioritizeSeoTags>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {keywords && <meta name="keywords" content={Array.isArray(keywords) ? keywords.join(", ") : keywords} />}
      <link rel="canonical" href={finalCanonical} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:url" content={finalOgUrl} />
      <meta property="og:locale" content="en_PK" />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:image:alt" content="Cyberpunk CDR Analyzer" />

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      <meta name="twitter:image" content={finalOgImage} />

      {asArray(schema).map((item, index) => (
        <script
          key={`ld-json-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </Helmet>
  );
}

export default SeoHelmet;
